
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

interface Report {
  name: string;
  description: string;
  path: string;
  module: string;
}

const reports: Report[] = [
  { name: "Tasks", description: "List of all retailers with details", module: "Tasks", path: "/reports/tasks" },
  { name: "Retailers", description: "Summary of sales across regions", module: "Retailers", path: "/reports/retailersreports" },
  { name: "Rewards and points", description: "Report of earned and redeemed points", module: "Rewards", path: "/reports/rewards-pointsreports" },
];

const ReportsTable = () => {
  return (
    <TableContainer component={Paper} sx={{ marginTop: 4 }}>
      <Typography variant="h6" sx={{ p: 2 }}>
        Reports
      </Typography>
      <Table>
        <TableHead sx={{ background: "#f5f5f5" }}>
          <TableRow>
            <TableCell><strong>Report Name</strong></TableCell>
            <TableCell><strong>Report Description</strong></TableCell>
            <TableCell><strong>Module</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reports.map((report, index) => (
            <TableRow key={index}>
              <TableCell>
                <Link
                  to={report.path}
                  style={{
                    textDecoration: "none",
                    color: "#1976d2",
                    fontWeight: 500,
                  }}
                >
                  {report.name}
                </Link>
              </TableCell>
              <TableCell>{report.description}</TableCell>
              <TableCell>{report.module}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReportsTable;
